import { canonicalKey } from '../domain/key';
import type { SearchRequest, SearchResponse } from '../domain/types';

/**
 * A second cache in front of the server's. Re-rolling the same answers or navigating
 * back shouldn't cost a round trip, let alone a billed Google call.
 */
const PREFIX = 'dcd:search:';
const TTL_MS = 60 * 60 * 1000;

interface Entry {
  at: number;
  response: SearchResponse;
}

export function readCached(request: SearchRequest): SearchResponse | null {
  try {
    const raw = sessionStorage.getItem(PREFIX + canonicalKey(request));
    if (!raw) return null;
    const entry = JSON.parse(raw) as Entry;
    if (Date.now() - entry.at > TTL_MS) return null;
    return { ...entry.response, cached: true };
  } catch {
    return null;
  }
}

export function writeCached(request: SearchRequest, response: SearchResponse): void {
  try {
    const entry: Entry = { at: Date.now(), response };
    sessionStorage.setItem(PREFIX + canonicalKey(request), JSON.stringify(entry));
  } catch {
    // Quota or private-mode failures are not worth surfacing.
  }
}
